(ns frontend.ui.component.badge.view
  (:require
   [frontend.ui.component.badge.style :as style]
   [herb.core :refer [<class]]))

(defn badge
  [props child]
  [:span
   (merge {:class (<class style/badge props)}
          (select-keys props [:on-click]))
   child])
